<template>
  <div class="account-page">
    <div class="main-wrapper">
      <layout-header></layout-header>
      <div class="main_home_content">
        <div class="container">
          <div class="row">
            <div class="col-md-10 offset-md-1 pt-5 pb-5">
              <!-- Login Tab Content -->
              <div class="home-content">
                <div class="row align-items-center justify-content-center">
                  <div class="col-md-7 col-lg-6">
                    <h1 :style="{ marginTop: '20px' }">
                      Automate, Document, and Analyze Every Patient Interaction
                    </h1>

                    <p :style="{ marginTop: '20px' }">
                      Provides a granular view of each patient interaction, from complaints to diagnoses, ensuring
                      informed decisions and personalised care.
                    </p>
                  </div>
                  <div class="col-md-12 col-lg-5">
                    <img style="height: 420px;" src="@/assets/img/encountera.png" class="img-fluid" alt="Doccure Login" />
                  </div>
                </div>
              </div>
              <!-- /Login Tab Content -->
            </div>
          </div>
        </div>
        <!-- Key Feature  Section-->
        <div class="row">
          <div class="col-md-10 offset-md-1">
            <h3 class="first_section_heading pb-5 pt-5" align="center">
              Key Features
            </h3>
            <b-card-group deck>
              <b-card border-variant="dark" header="Patient Encounter Logs to Capture Every Interaction"
                header-bg-variant="dark" header-text-variant="white">

                <b-card-text>Document every patient interaction, from initial complaints and symptoms to the provided
                  treatments and follow-ups. Maintain a chronological record for future reference and continuity of
                  care.</b-card-text>
              </b-card>
              <b-card border-variant="dark" header="Complaint Analysis for Understanding Patient Concerns"
                header-bg-variant="dark" header-text-variant="white">

                <b-card-text>Delve into the specifics of each patient complaint, categorising and analysing them to ensure
                  appropriate and effective responses.</b-card-text>
              </b-card>
              <b-card border-variant="dark" header="Diagnosis Overview for A Clear Picture of Patient Health"
                header-bg-variant="dark" header-text-variant="white">
                <b-card-text>Review detailed diagnostic information, from clinical findings to lab results. Ensure
                  accurate and timely interventions based on comprehensive data.</b-card-text>
              </b-card>
            </b-card-group>
            <b-card-group deck style="margin-top: 30px;margin-bottom: 40px;">
              <b-card border-variant="dark" header="Treatment Analysis to Track and Evaluate Treatment Efficacy"
                header-bg-variant="dark" header-text-variant="white">

                <b-card-text>Monitor prescribed treatments' outcomes, evaluate their effectiveness, and make necessary
                  adjustments for optimal patient outcomes.</b-card-text>
              </b-card>
              <b-card style="border: none;"> </b-card>
            </b-card-group>
          </div>
        </div>
        <!-- Benefit Section -->

        <div class="row">
          <div class="col-md-10 offset-md-1">

            <h3 style="text-align: center; padding-bottom: 20px; margin-top: 40px;margin-bottom: 40px;">
              Enhancing Care Through Insightful Analysis
            </h3>
            <b-card-group deck>
              <b-card border-variant="dark" header="Comprehensive View" header-bg-variant="dark"
                header-text-variant="white">
                <b-card-text>Obtain a 360-degree view of patient interactions, ensuring
                  nothing is overlooked.</b-card-text>
              </b-card>
              <b-card border-variant="dark" header=" Efficiency" header-bg-variant="dark" header-text-variant="white">
                <b-card-text>Reduce manual documentation efforts, freeing up time for patient
                  care.</b-card-text>
              </b-card>
              <b-card border-variant="dark" header="Insights" header-bg-variant="dark" header-text-variant="white">
                <b-card-text>Derive actionable insights from encounter data to improve patient
                  outcomes.</b-card-text>
              </b-card>
            </b-card-group>
            <b-card-group deck style="margin-top: 30px;">
              <b-card border-variant="dark" header="Collaboration" header-bg-variant="dark" header-text-variant="white">
                <b-card-text>Foster a team-based approach to patient care with shared insights
                  and data.</b-card-text>
              </b-card>
              <b-card style="border: none;"> </b-card>
              <b-card style="border: none;"> </b-card>
            </b-card-group>
            <!--Call Action Section -->
            <div class="mt-5" style="display: flex; justify-content: center; align-items: center;">
              <div style="width: 500px; text-align: center;">
                <b-card bg-variant="info" text-variant="white" title="" style="border: 1px solid black;">
                  <b-card-text style="text-align: center;">
                    Experience the future of patient encounter management with
                    {{main_data}} advanced system. Register today and
                    leverage data-driven insights for superior patient care!
                  </b-card-text>
                  <b-button href="#" variant="dark" style="text-align: center;">
                    Register Now
                  </b-button>
                </b-card>
              </div>
            </div>
          </div>
        </div>
      </div>
      <layout-footer></layout-footer>
    </div>
  </div>
</template>
<script>
import config from "../../services/CommonApi";
import axios from "axios";
export default {
  data() {
    return {
      main_data: "",
      config: config,
    };
  },
  mounted() {
    this.get_practitioner_profile();
  },
  methods: {

    async get_practitioner_profile() {
      var domain = window.location.hostname;

      const formdata = {
        domain: window.location.hostname,
      };
      await axios
        .get(
          "https://develop-physio.kneexpert.in/api/method/sahaj.domain.get_hospital?domain=" +
          window.location.hostname
        )
        .then((res) => {
          this.showspinner = false;
          if (res.data.status_code == 200) {
            this.main_data = res.data.data[0].brand_name
          }
          if (res.data.status_code == 404) {
            if (window.location.hostname == "physio.sahajhelp.com") {
                       } else if (window.location.hostname == "physio.kneexpert.in") {
            } else if (window.location.hostname == "localhost") {
            }
            else if (window.location.hostname.startsWith("192.168")) {
            } else if (window.location.hostname == "iitb.smartyhealthcare.in") {
            } else {
              window.location.href = String("https://physio.kneexpert.in");
            }
          }
          this.$swal.close();
        });
    },

  },
}
</script>


// WEBPACK FOOTER //
// src/components/kneexpert/AutomatedPatientEncounter.vue